module.exports = __webpack_public_path__ + "img/filter.8a9ddbdc.svg";